import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AppProvider, useApp } from './context/AppContext';
import { CurrencyProvider } from './context/CurrencyContext';
import { CustomerAuthProvider } from './context/CustomerAuthContext';
import { WishlistProvider } from './context/WishlistContext';
import AgeGate from './components/AgeGate';
import Home from './pages/Home';
import AdminPage from './pages/AdminPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

const Gated = () => {
  const { ageAccepted } = useApp();
  if (!ageAccepted) return <AgeGate />;
  return <Home />;
};

function App() {
  return (
    <div className="App">
      <Toaster position="bottom-left" richColors closeButton toastOptions={{ style: { fontFamily: 'Inter, sans-serif' } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/*" element={
            <CustomerAuthProvider>
              <AppProvider>
              <CurrencyProvider>
                <WishlistProvider>
                  <Gated />
                </WishlistProvider>
              </CurrencyProvider>
              </AppProvider>
            </CustomerAuthProvider>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
